// extracted by mini-css-extract-plugin
export default {"footerContainer":"ChatToChannelInfoModal__footerContainer___FQs8p"};